/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Buyer_EditInputs */

const vi_einvoice_buyer_edit = /** @type {(inputs: Einvoice_Buyer_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sửa thông tin hóa đơn`)
};

/**

* @param {Einvoice_Buyer_EditInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_buyer_edit = /** @type {((inputs?: Einvoice_Buyer_EditInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Buyer_EditInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_buyer_edit(inputs)
});